import http from "../config/axios";


export async function create_neighborhood_info(neighborhoodInfo:any) {
    const url = `/neighborhood_info/create`;
    try {
        const response = await http.request({
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            url,
            data: neighborhoodInfo,
        });
        return response.data;
    } catch (error) {
        console.error("Erro ao criar bairro:", error);
        throw error;
    }
}

export async function listNeighborhoodInfos(limit = 200, offset = 0) {
    try {
        const response = await http.request({
            method: "GET",
            url: "/neighborhood_info/list",
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                limit,
                offset,
            },
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar informações dos bairros:", error);
        throw error;
    }
}

export async function get_neighborhood_by_city(
    city:any, limit = 200, offset = 0) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/neighborhood_info/by_city`,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                city,
                limit,
                offset,
            },
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar informações dos bairros:", error);
        throw error;
    }
}
export async function get_neighborhood_exclude_restaurant(
    restaurantId:any, limit = 200, offset = 0) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/neighborhood_info/exclude_restaurant_vinculated`,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                restaurant_id: restaurantId,
                limit,
                offset,
            },
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar informações dos bairros:", error);
        throw error;
    }
}
export async function getNeighborhoodInfoById(neighborhoodId:any) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/neighborhood_info/detail/${neighborhoodId}`,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar informações do bairro:", error);
        throw error;
    }
}




export async function deleteNeighborhoodInfo(neighborhood_id:any) {
    try {
        const response = await http.delete(`/neighborhood_info/delete/${neighborhood_id}`);
        return response.data;
    } catch (error:any) {
        if (error.response && error.response.status === 422) {
            console.error("Erro ao excluir o bairro: O bairro ainda está em uso.");
        } else {
            console.error("Erro ao excluir o bairro:", error);
        }
        throw error;
    }
}


export async function getDeliveryTaxByRestaurantId(restaurantId:any, limit = 200, offset = 0) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/delivery_tax/by_restaurant/${restaurantId}`,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                limit,
                offset,
            },
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar taxas de entrega:", error);
        throw error;
    }
}

export async function createDeliveryTax(requestBody:any) {
    try {
        const response = await http.post("/delivery_tax/create", requestBody, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Erro ao criar taxa de entrega:", error);
        throw error;
    }
}

export async function updateDeliveryTax(deliveryTaxId:any, deliveryTaxData:any) {
    try {
        const response = await http.patch(`/delivery_tax/update/${deliveryTaxId}`, deliveryTaxData);
        return response.data;
    } catch (error) {
        console.error("Erro ao atualizar a taxa de entrega:", error);
        throw error;
    }
}

export async function deleteDeliveryTax(deliveryTaxId:any) {
    try {
        const response = await http.delete(`/delivery_tax/delete/${deliveryTaxId}`);
        return response.data;
    } catch (error) {
        console.error("Erro ao excluir a taxa de entrega:", error);
        throw error;
    }
}



export async function getStates() {
    try {
        const response = await http.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados');
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar estados:", error);
        throw error;
    }
}

export async function getCities(stateId:any) {
    try {
        const response = await http.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${stateId}/municipios`);
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar cidades:", error);
        throw error;
    }
}
